import NumberKeyboard from './NumberKeyboard';

export default NumberKeyboard;
export { NumberKeyboard };
export type { KeyType, NumberKeyboardTheme, KeyConfig, NumberKeyboardProps } from './types';
